import { render, staticRenderFns } from "./myFeedback.vue?vue&type=template&id=a7421df2&scoped=true&"
import script from "./myFeedback.vue?vue&type=script&lang=js&"
export * from "./myFeedback.vue?vue&type=script&lang=js&"
import style0 from "./myFeedback.vue?vue&type=style&index=0&id=a7421df2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7421df2",
  null
  
)

export default component.exports